import React from 'react';
import { useState, useEffect, useRef } from 'react';
import './Landing.css';


function Landing() {

  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
      setIsVisible(true);
  }, []);

  return (
    <section id="home" 
    className="bg-gradient-to-r from-emerald-900 from-10% via-emerald-800 via-50% to-emerald-700
    min-h-screen flex items-center justify-center text-white"
    >
      <div className={`text-center px-6 fade-in ${isVisible ? 'visible' : ''}`}>
          <h1 className="text-5xl md:text-7xl font-bold mb-6">Project Leadership</h1>
          <p className="text-xl md:text-2xl mb-8 opacity-90">Exceeding expectations in delivering complex projects on time and within budget.</p>
          <div className="grid grid-cols-3 gap-8 mb-8 max-w-2xl mx-auto">
              <div className="text-center">
                  <div className="text-3xl font-bold">10+</div>
                  <div className="text-sm opacity-80">Projects Delivered</div>
              </div>
              <div className="text-center">
                  <div className="text-3xl font-bold">$2B+</div>
                  <div className="text-sm opacity-80">Budgetary Impact</div>
              </div>
              <div className="text-center">
                  <div className="text-3xl font-bold">4+</div>
                  <div className="text-sm opacity-80">Industries Served</div>
              </div>
          </div>
          <div className="space-x-4 flex items-center justify-center">
              <button 
                  onClick={() => document.getElementById('projects').scrollIntoView({ behavior: 'smooth' })}
                  className="bg-white text-emerald-800 px-8 py-3 rounded-full font-semibold hover:bg-gray-100 transition-colors max-w-60"
              >
                  View Portfolio
              </button>
              <button 
                  onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })}
                  className="border-2 border-white px-8 py-3 rounded-full font-semibold hover:bg-white hover:text-emerald-800 transition-colors max-w-60"
              >
                  Let's Connect
              </button>
          </div>
      </div>
    </section>
  );
}

export default Landing;